import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TruckOverviewActionBarComponent } from './component/truck-overview-action-bar.component';
import { MaterialModule } from '@sdbn/appclient';
import { DictionaryModule } from '@sdbn/appclient';
import { CommonLayoutModule, CommonTranslationModule, CommonUIElementsModule } from '@sdbn/common';

@NgModule({
  declarations: [
    TruckOverviewActionBarComponent
  ],
  imports: [
    CommonModule,
    DictionaryModule,
    MaterialModule,
    CommonLayoutModule,
    CommonTranslationModule,
    CommonUIElementsModule
  ],
  exports: [
    TruckOverviewActionBarComponent
  ]
})
export class TruckOverviewActionBarModule { }
